import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';

interface IHeaderForm {
  respuesta: string
  observaciones: string
}

interface ICallbackInput {
  (result: 0 | 1 | 2, observacion: string, additionalData: any): void
}

@Component({
  selector: 'app-empresas-recibidos-modal-resp-com',
  templateUrl: './modal-resp-com.component.html',
  styleUrls: ['./modal-resp-com.component.scss']
})
export class EmpresasRecibidosModalRespComComponent implements OnInit {

  @Input() relativeId: string = ''
  public idAceptado = `${this.relativeId}__AE_EMP_RECIB_RTA_ACEPTADO__`
  public idAceptadoConDiscrepancias = `${this.relativeId}__AE_EMP_RECIB_RTA_ACEPTADO_CON_DISCREPANCIAS__`
  public idRechazado = `${this.relativeId}__AE_EMP_RECIB_RTA_RECHAZADO__`

  @ViewChild('observacionesModal', { static: true }) modalObservaciones: ModalDirective;

  // Constants
  // readonly EMP_RECIB_RTA_ACEPTADO: String = `_EMP_RECIB_RTA_ACEPTADO_`
  // readonly EMP_RECIB_RTA_ACEPTADO_CON_DISCREPANCIAS: String = `_EMP_RECIB_RTA_ACEPTADO_CON_DISCREPANCIAS_`
  // readonly EMP_RECIB_RTA_RECHAZADO: String = `_EMP_RECIB_RTA_RECHAZADO_`
  readonly EMP_RECIB_RTA_ACEPTADO: number = 0
  readonly EMP_RECIB_RTA_ACEPTADO_CON_DISCREPANCIAS: number = 1
  readonly EMP_RECIB_RTA_RECHAZADO: number = 2

  // Form
  formHeader: FormGroup;
  initialValues: IHeaderForm

  // Callbacks
  private acceptCallback: ICallbackInput;
  private additionalData: any

  // Utils
  private log: any

  constructor(
    private clog: ConsoleService,
    private toastService: ToastService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService
  ) {
    this.log = this.clog.log('EMPRESAS-RECIBIDOS-OBSERVACIONES')
  }

  ngOnInit() {
    this.createFormInitialValues()
    this.createForms()
    this.idAceptado = `${this.relativeId}__AE_EMP_RECIB_RTA_ACEPTADO__`
    this.idAceptadoConDiscrepancias = `${this.relativeId}__AE_EMP_RECIB_RTA_ACEPTADO_CON_DISCREPANCIAS__`
    this.idRechazado = `${this.relativeId}__AE_EMP_RECIB_RTA_RECHAZADO__`
  }

  createFormInitialValues() {
    this.initialValues = {
      respuesta: null,
      observaciones: null,
    }
  }

  private createForms() {
    this.formHeader = this.fb.group({
      respuesta: [null, [Validators.required]],
      observaciones: [null, [Validators.required, Validators.maxLength(200)]],
    });
  }

  show({ acceptCallback, additionalData }: { acceptCallback: ICallbackInput, additionalData: any }) {
    this.acceptCallback = acceptCallback
    this.additionalData = additionalData
    this.setInitialValues()
    this.modalObservaciones.show()
  }

  private setInitialValues() {
    this.formValidatorsService.setInitialState(this.formHeader, this.initialValues)
  }

  agregarObservacion() {
    this.formValidatorsService.validateAllFormFields(this.formHeader)
    if (!this.formHeader.valid)
      return

    const { respuesta, observaciones } = this.formHeader.value

    if (this.acceptCallback)
      this.acceptCallback(respuesta, observaciones, this.additionalData)

    this.modalObservaciones.hide()
  }

}
